import gql from 'graphql-tag';

export const SELECT_OFFER_AND_COMPANY_TYPE = gql`
  mutation SelectOfferAndCompanyType(
    $offerId: ID!
    $existingCompany: Boolean!
    $packageSelected: Int
  ) {
    selectOfferAndCompanyType(
      offerId: $offerId
      existingCompany: $existingCompany
      packageSelected: $packageSelected
    )
  }
`;
